import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
    studentList: [],
    loading: false,
    success: false,
    enrollmentList: [],
    loadingEnrollments: false,
    loadingEnrollSingleItem: false,
    studentCount: 0
};

const studentSlice = createSlice({
    name: 'student',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setSuccess(state, action) {
            state.success = action.payload;
        },
        setStudentList(state, action) {
            state.studentList = action.payload;
        },
        setEnrollList(state, action: PayloadAction<any>) {
            state.enrollmentList = action.payload
        },
        setLoadingEnrollments(state, action: PayloadAction<any>) {
            state.loadingEnrollments = action.payload
        },
        setLoadingEnrollSingleItem(state, action: PayloadAction<any>) {
            state.loadingEnrollSingleItem = action.payload
        },
        setStudentCount(state, action: PayloadAction<any>) {
            state.studentCount = action.payload
        }
    },
});

export const {
    setLoading,
    setSuccess,
    setStudentList,
    setEnrollList,
    setLoadingEnrollments,
    setLoadingEnrollSingleItem,
    setStudentCount
} = studentSlice.actions;

export default studentSlice.reducer;
